import React from "react";
import { useSkin } from "../../skins/SkinContext";
import { SkRect } from "../../prim";
import { skSun, skCloud, skTree, skFlower, skPerson } from "../../actors3";
import { skBush, skGrassTuft } from "../../actors3/nature";
import { skDog, skBird, skButterfly } from "../../actors3/animals";

/*
 * Anivaze v3 — a skin-aware CONCEPT SCENE composed entirely from the rebuilt
 * actor library. Reads the global skin, so it re-renders in Studio / Hand-drawn /
 * Flat / Doodle with the Skin picker. This is what real lesson scenes look like
 * in v3: arrangements + choreography of skin-aware actors.
 */
export interface SkinSceneProps {
  opacity?: number;
  accentColor?: string;
  label?: string;
  t?: number;
}

export const SkinParkScene: React.FC<SkinSceneProps> = ({ opacity = 1, t = 0, label = "A sunny day at the park!" }) => {
  const skin = useSkin();
  const ground = 332;
  const cloudX = ((t * 15) % 1040) - 80;
  // a butterfly flutters along a gentle path
  const bx = 360 + Math.sin(t * 0.7) * 150;
  const by = 150 + Math.sin(t * 1.7) * 26;
  const birdX = ((t * 40) % 980) - 60;
  return (
    <g opacity={opacity}>
      <rect width={800} height={450} fill={skin.surface} />
      <SkRect x={0} y={ground} w={800} h={450 - ground} fill="#86efac" seed={901} />

      {skSun(108, 80, t, 1.1)}
      {skCloud(cloudX, 90, 1)}
      {skBird(birdX, 120, t, 1)}

      {skTree(140, ground, t, 1.2)}
      {skTree(700, ground, t, 0.95)}
      {skBush(250, ground, t, 1)}
      {skBush(610, ground, t, 0.9)}
      {skGrassTuft(70, ground, t, 1)}
      {skGrassTuft(470, ground, t, 1)}

      {skFlower(330, ground, t, 0.8, "#fb7185")}
      {skFlower(370, ground, t, 0.7, "#a78bfa")}
      {skFlower(560, ground, t, 0.75, "#f59e0b")}

      {skButterfly(bx, by, t, 1.1)}
      {skPerson(420, ground, t, 1.55, true)}
      {skDog(500, ground, t, 1.0)}

      <g transform="translate(400 40)">
        <rect x={-235} y={-22} width={470} height={40} rx={20} fill="rgba(255,255,255,0.86)" stroke="#cbd5e1" strokeWidth={1.5} />
        <text x={0} y={4} textAnchor="middle" fill={skin.textInk} fontSize={16} fontWeight={700} fontFamily={skin.fontFamily}>{label}</text>
      </g>
    </g>
  );
};
